import type { ReducerErrorListener } from "../types";

/**
 * Provides support for global error handling for root saga and root reducer. This class forwards uncaught errors from root reducer and root saga
 * to ErrorBoundary component, so it can display generic error page. ErrorBoundary registers its error handler by register methods. Setup module
 * connect trigger methods to error handlers while creating store.
 *
 * Events are not generic, but specific, because they are intended only for specific case of top level, last resort error handling.
 * This class should not be used in API calls error handling.
 */
export class GlobalErrorEvents {
    private static readonly reducerErrorListener?: ReducerErrorListener;

    /**
     * Triggers error event for reducer. This method should be used only by setup module.
     * @param error
     */
    public static triggerReducerErrorEvent(error: unknown) {
        if (GlobalErrorEvents.reducerErrorListener) {
            GlobalErrorEvents.reducerErrorListener(error);
        } else {
            // eslint-disable-next-line no-console
            console.warn("Reducer error was triggered before error handler was registered.");
        }
    }

    constructor() {
        throw new Error("GlobalErrorEvents is static class and cannot be instantiated.");
    }
}
